import { ManualIconCellRenderer } from "@/controls/ag-grid/components/ButtonCellRenderer";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-enterprise";
import moment from "moment";
import { CategoryTag } from "./CategoryTag";

type Props = {};

export const useTableData = ({}: Props) => {
	const columns: ColDef[] = [
		{
			field: "AssetName",
			headerName: "Asset",
			maxWidth: 95,
			minWidth: 95,
			editable: false,
			flex: 1,
		},
		{
			field: "Start",
			headerName: "Start",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.Start}`, "HH:mm:ss") || "",
			minWidth: 80,
			flex: 1,
		},
		{
			field: "End",
			headerName: "End",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.End}`, "HH:mm:ss") || "",
			minWidth: 80,
			flex: 1,
		},
		{
			field: "Duration",
			headerName: "Duration",
			valueFormatter: (params) => {
				if (params.value) {
					const duration = moment.duration(params.value, "seconds");
					const minutes = Math.floor(duration.asMinutes());
					const seconds = duration.seconds();
					return `${minutes}m ${seconds}s`;
				}
				return "";
			},
			minWidth: 110,
			flex: 1,
		},
		{
			field: "DelayCategory",
			headerName: "Category",
			valueGetter: (params) => {
				const delayCategoryName = params.data?.DelayCategoryName;
				const delayCategoryColor = params.data?.DelayCategoryColor;
				return { name: delayCategoryName, color: delayCategoryColor };
			},
			cellRenderer: CategoryTag,
			maxWidth: 150,
			minWidth: 150,
			editable: false,
			flex: 1,
		},
		{
			field: "DelayCodeName",
			headerName: "Code",
			valueGetter: (params) => params.data?.DelayCodeName || "No Classified",
			minWidth: 150,
			editable: false,
			flex: 1,
		},
		{
			field: "Comments",
			headerName: "Comments",
			minWidth: 118,
			flex: 5,
		},
		{
			field: "JustifiedByUser",
			headerName: "User",
			minWidth: 100,
			editable: false,
			flex: 1,
		},
		{
			field: "JustifiedDatetime",
			headerName: "Justification Date",
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data?.JustifiedDatetime, "MM/dd - HH:mm"),
			minWidth: 180,
			flex: 1,
		},
		{
			field: "IsManual",
			headerName: "",
			type: ["nonSorteable", "nonFilterable", "centerAligned"],
			cellRenderer: ManualIconCellRenderer,
			cellClass: "ag-button-cell",
			flex: 1,
			maxWidth: 60,
		},
		{
			field: "Name",
			headerName: "",
			type: ["nonSorteable", "nonFilterable", "optionsButton"],
			maxWidth: 150,
			minWidth: 150,
			editable: false,
			flex: 1,
		},
	];

	return { columns };
};
